import { Modal } from "antd";
import i18n from "i18next";
import type { ReactNode } from "react";

import { PrimaryButton, SecondaryButton } from "../Buttons/components/ActionButton";

interface ModalProps {
    onOk: () => void;
    onCancel: () => void;
    visible?: boolean;
    message?: ReactNode;
    title?: string;
}

export const ConfirmationModal = ({ onCancel, onOk, visible, message, title }: ModalProps) => {
    return (
        <Modal
            closable
            open={visible}
            onCancel={onCancel}
            title={title}
            footer={[
                <PrimaryButton key="ok" onClick={onOk}>
                    {i18n.t("form.ok")}
                </PrimaryButton>,
                <SecondaryButton key="cancel" onClick={onCancel}>
                    {i18n.t("form.cancel")}
                </SecondaryButton>,
            ]}
        >
            {typeof message === "string" ? <p>{message}</p> : message}
        </Modal>
    );
};
